<template>
    <Button
        v-if="hasMore || props.loading"
        :loading="props.loading"
        :class="{ loading: props.loading }"
        class="tertiary size-l explorer-ignore"
        :name="loadMoreTitle"
    />
</template>

<script setup>
    import { computed } from 'vue';
    import { useI18n } from 'vue-i18n';

    import Button from '🔗/components/ui/Button.vue';

    const props = defineProps({
        loading: { type: Boolean, default: true },
        total: { type: Number, default: 0 },
        take: { type: Number, default: 20 },
        values: { type: Array, default: () => ([]) },
        pluralization: { type: String, default: '' }
    });

    const { t } = useI18n();

    const hasMore = computed(() => props.values.length < props.total);

    const moreCount = computed(() => Math.min(props.total - props.values.length, props.take));

    const loadMoreTitle = computed(() => {
        return t(`pluralization.${ props.pluralization }s.more`, {
            count: moreCount.value,
            item: t(`pluralization.${ props.pluralization }s.${ props.pluralization }`, moreCount.value)
        });
    });
</script>

<style lang="scss" scoped>
button {
    margin: 0 auto;
    &.loading {
        width: 120px;
    }
}
</style>
